export const getScrollParent = (node) => {
  const regex = /(auto|scroll)/;
  const parents = (_node, ps) => {
    if (_node.parentNode === null) { return ps; }
    return parents(_node.parentNode, ps.concat([_node]));
  };

  const style = (_node, prop) => getComputedStyle(_node, null).getPropertyValue(prop);
  const overflow = _node => style(_node, 'overflow') + style(_node, 'overflow-y') + style(_node, 'overflow-x');
  const scroll = _node => regex.test(overflow(_node));

  /* eslint-disable consistent-return */
  const scrollParent = (_node) => {
    if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
      return;
    }

    const ps = parents(_node.parentNode, []);

    for (let i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent(node);
  /* eslint-enable consistent-return */
};

export default {
  bind(el, binding) {
    const elStyle = el.style
    const params = binding.value || {}
    const stickyVal = params.stickyVal || 0
    const type = params.type || 'top'
    const zIndex = params.zIndex || 1000

    el._stickyState = { stickyVal, type, zIndex, className: params.className }

    elStyle.position = '-webkit-sticky'
    elStyle.position = 'sticky'

    if (~elStyle.position.indexOf('sticky')) {
      elStyle[type] = `${stickyVal}px`
      elStyle.zIndex = zIndex
      return
    }

    elStyle.position = 'relative'
  },
  inserted: function (el) {
    const state = el._stickyState || {}
    const stickyVal = state.stickyVal || 0
    const type = state.type || 'top'
    const scrollElement = getScrollParent(el) || window
    let active = false
    const elStyle = el.style

    const sticky = () => {
      if (active) {
        return
      }
      if (!elStyle.height) {
        elStyle.height = `${el.offsetHeight}px`
      }
      active = true
    }

    const reset = () => {
      if (!active) {
        return
      }
      active = false
    }

    const check = () => {
      if(type === 'top') {
        const offsetTop = el.getBoundingClientRect().top
        const top = scrollElement instanceof Window ? 0 : scrollElement.getBoundingClientRect().top;
        if (offsetTop <= stickyVal + top) {
          sticky()
          return
        }
        reset()
      } else {
        const offsetBottom = el.getBoundingClientRect().bottom
        const bottom = scrollElement instanceof Window ? 0 : scrollElement.getBoundingClientRect().bottom;
        if (offsetBottom + stickyVal  === bottom) {
          sticky()
          return
        }
        reset()
      }
    }

    const listenAction = () => {
      if(!scrollElement.requestAnimationFrame){
        return setTimeout(check, 16)
      }
      scrollElement.requestAnimationFrame(check)
    }

    el._stickyState = { ...state, scrollElement, listenAction }
    scrollElement.addEventListener('scroll', listenAction)
    check()
  },
  unbind(el) {
    const state = el._stickyState
    if (state?.scrollElement && state?.listenAction) {
      state.scrollElement.removeEventListener('scroll', state.listenAction)
    }
    delete el._stickyState
  },

  update(el, binding) {
    const params = binding.value || {}
    const state = el._stickyState || {}
    const stickyVal = params.stickyVal || 0
    const zIndex = params.zIndex || 1000
    const type = state.type || 'top'
    state.stickyVal = stickyVal
    state.zIndex = zIndex
    state.className = params.className || ''
    let childStyle = el.firstElementChild.style
    el.style[type] = childStyle[type] = `${stickyVal}px`
    el.style.zIndex = childStyle.zIndex = zIndex
  },
}
